module.exports = __webpack_public_path__ + "static/driver-on-the-road-alternate-e0f6fe5804352e991364fbdba21eeaab.jpg";